<div
  class="spinner-wrapper"
  [ngStyle]="{ display: loading ? 'block' : 'none' }"
>
  <div class="spinner"></div>
</div>
